module.exports = __webpack_public_path__ + "img/品質管理1-4.4cdcda44.png";